import { Markup } from "interweave";
import moment from "moment";
import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Box from "../../../../../../Assets/Images/Souvenir/box.png";
import Delivery from "../../../../../../Assets/Images/Souvenir/delivery.png";
import Clock from "../../../../../../Assets/Icon/pending.png";
import { serverInfo } from "../../../../../../App";
import { LocationContext } from "../../../../../../CustomHelper/Helper";

const PurchaseModal = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);
  const product = props?.activity;

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
        centered
        className=""
      >
        <Modal.Body className="">
          <div className="row m-3">
            <h5 className="text-light mb-3">Purchase status</h5>
            <div className="col-md-5 d-flex">
              <img
                src={imageCdnUrl + product.marketplace?.image}
                alt=""
                className="img-fluid PurImg mb-3"
                style={{ height: "350px" }}
              />
            </div>

            <div className="col-md-7 d-flex">
              <div className="row">
                <div className="owner d-flex text-light">
                  <div className="SpLeft d-flex col-md-3 fw-bold">Owner</div>
                  <div className="SpRight d-flex col-md-9">
                    {product.marketplace?.superstar?.first_name}{" "}
                    {product.marketplace?.superstar?.last_name}
                  </div>
                </div>
                <div className="owner d-flex text-light">
                  <div className="SpLeft d-flex col-md-3 fw-bold">
                    Description
                  </div>
                  <div className="SpRight spDescripton d-flex col-md-9">
                    <Markup content={product.marketplace?.description} />
                  </div>
                </div>
                <div className="owner d-flex text-light">
                  <div className="SpLeft d-flex col-md-3 fw-bold">Price</div>
                  <div className="SpRight d-flex col-md-9">
                    &nbsp; {paymentCountWithSymbol(product.total_price)}
                  </div>
                </div>
                <div className="owner d-flex text-light">
                  <div className="SpLeft d-flex col-md-3 fw-bold">Ordered</div>
                  <div className="SpRight d-flex col-md-9">
                    {moment(product.created_at).format("LL")}
                  </div>
                </div>

                {Number(product.status) === "2" ? (
                  <div className="owner d-flex text-light">
                    <div className="SpLeft d-flex col-md-3 fw-bold">
                      Paid on
                    </div>
                    <div className="SpRight d-flex col-md-9">
                      {moment(product.delivery_at).format("LL")}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="owner d-flex text-light">
                  <div className="SpLeft d-flex col-md-3 fw-bold">Status</div>
                  {Number(product.status) === 1 ? (
                    <div className="SpRight d-flex col-md-9 text-warning ">
                      Ordered
                    </div>
                  ) : Number(product.status) === 2 ? (
                    <div className="SpRight d-flex col-md-9 text-warning ">
                      Received
                    </div>
                  ) : Number(product.status) === 3 ? (
                    <div className="SpRight d-flex col-md-9 text-warning ">
                      Out for Delivery
                    </div>
                  ) : (
                    <div className="SpRight d-flex col-md-9 text-warning ">
                      Delivered
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
              <div className="">
                <div className="BoxR mx-3 btn-warning text-light p-2">
                  <img src={Clock} alt="" className="DeliveryImg" />
                </div>
                <p className="text-light text-center PSize">Ordered</p>
              </div>
              <span className="Box-Line"></span>

              <div className="">
                {Number(product.status) >= 2 ? (
                  <div className="BoxR  mx-3 btn-warning text-light p-2">
                    <img src={Box} alt="" className="DeliveryImg" />
                  </div>
                ) : (
                  <div className="BoxR PenCol mx-3 btn-warning text-light p-2">
                    <img src={Box} alt="" className="DeliveryImg" />
                  </div>
                )}
                <p className="text-light text-center PSize">Received</p>
              </div>
              <span className="Box-Line"></span>

              <div className="">
                {Number(product.status) >= 3 ? (
                  <div className="BoxR  mx-3 btn-warning text-light p-2">
                    <img src={Delivery} alt="" className="DeliveryImg" />
                  </div>
                ) : (
                  <div className="BoxR PenCol mx-3 btn-warning text-light p-2">
                    <img src={Delivery} alt="" className="DeliveryImg" />
                  </div>
                )}
                <p className="text-light text-center PSize">Out for Delivery</p>
              </div>
              <span className="Box-Line"></span>

              <div className="">
                {Number(product.status) == 4 ? (
                  <div className="BoxR mx-3 btn-warning text-light p-2">
                    <img src={Box} alt="" className="DeliveryImg" />
                  </div>
                ) : (
                  <div className="BoxR PenCol mx-3 btn-warning text-light p-2">
                    <img src={Box} alt="" className="DeliveryImg" />
                  </div>
                )}
                <p className="text-light text-center PSize">Delivered</p>
              </div>
            </div>
          </div>
          <i
            className="fas fa-times-circle text-warning top-right_cross btn"
            onClick={props.onHide}
          ></i>
          {/* <img src={Message} alt="" className='ImgRightP' /> */}
          <Link to={`/marketplace/invoice/${product.id}`}>
            <Button>
              <i
                className="fa fa-download"
                title="Invoice Download"
                style={{ color: "gold" }}
              ></i>
            </Button>
          </Link>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PurchaseModal;
